var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"com-nodata flex center column"},[(_vm.computedSrc)?_c('img',{staticClass:"com-nodata--image mpm-bg",style:({
      height: _vm.computedHeight,
    }),attrs:{"src":_vm.computedSrc}}):_vm._e(),(_vm.text)?_c('div',{staticClass:"com-nodata--text mpm-align-center mpm-tclr-cont mpm-mt12"},[_vm._v(_vm._s(_vm.text))]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }